"use client"

import { useState, useEffect, useContext } from "react"
import { TableDownloadContext } from "../../Contexts/TableDownloadContext"
import moment from "moment"
import "../MainMenu.css"
import ExportPopup from "../../Components/ExportPopup"
import {
  investorProfileExportData,
  investorbackedIPOExportData,
  investorAngelInvestmentExportData,
  investorexitExportData,
  investorincubationExportData,
} from "../../Components/ExportPopup/ExportData"
import { exportInvestorExcel } from "../../Config/config"
import { TableDataContext } from "../../Contexts/TableDataContext"
import { PeFilterContext } from "../../Contexts/PeFilterContext"
import Constants from "../../Constants"
import { UserContext } from "../../Contexts/UserContext"
import { useLocation } from "react-router"
import { ExportDirectoryExcel } from "../ExportPopup/DirectoryExport"
import DownloadTrigger from "../ExportPopup/DownloadTrigger"

function MainMenu(props) {
  const { handleDownloadExcel } = useContext(TableDownloadContext)
  const { setCurrentPage, globalSearchResult } = useContext(TableDataContext)

  const [showPopup, setShowPopup] = useState(false)

  useEffect(() => {
    if (window.innerWidth < 800) {
      // setOpen(true)
      setIsMobile(true)
    }
  }, [])

  const { save, setSave, showMonthPicker, refineSearchFilters, groupId, isMobile, setOpen, open, setIsMobile } =
    useContext(PeFilterContext)
  const { pathname } = useLocation()

  const [date, setDate] = useState([
    moment().startOf("month").subtract(12, "months").format("YYYY-MM-DD"),
    moment().endOf("month").format("YYYY-MM-DD"),
  ])

  const { isStudent, isDirectoryUser, isTrialExport } = useContext(UserContext)

  const download = () => {
    handleDownloadExcel()
  }

  const isFromGlobalSearch = () => (refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false)

  const category =
    props.menu === "investor"
      ? "pevc_count"
      : props.menu === "pevcExit"
        ? "exit_count"
        : props.menu === "backedipo"
          ? "ipo_count"
          : props.menu === "angel"
            ? "angel_count"
            : props.menu === "incubation"
              ? "incubation_count"
              : ""

  const titleMap = {
    investor: "PE Investors PE-VC Investment - Venture Intelligence",
    pevcExit: "PE Investors PE-VC Exits - Venture Intelligence",
    maPeExit: "PE Investors Exits Via M&A (PE-VC) - Venture Intelligence",
    public_pevc: "PE Investors Exits Via Public Market (PE-VC) - Venture Intelligence",
    backedipo: "PE Investors PE-VC Backed IPOs - Venture Intelligence",
    angel: "PE Investors Angel Investments - Venture Intelligence",
    incubation: "PE Investors Incubation - Venture Intelligence",
  }

  document.title = titleMap[props.menu] || "Venture Intelligence"

  return (
    <div className="pl-3 pr-4 lg:pr-4 md:pr-5">
      <div className="scrollbar rounded shadow-[0_2px_6px_0_rgba(0,0,0,0.08)]">
        <div className="px-2 md:px-3 rounded-[6px] rounded-b-none bg-white block lg:flex flex-row justify-between">
          {/* Empty div replacing all navigation links */}
          <div className="flex flex-row px-3 lg:px-2 overflow-x-auto space-x-5 scrollbar-remove">
            {/* Navigation content removed - empty space */}
          </div>

          <div
            className={
              "md:flex justify-between items-center px-3 lg:px-2 py-2 space-x-4 " + (showMonthPicker != 0 ? "" : "flex")
            }
          >
            <div></div>
            <div className={showMonthPicker != 0 ? "hidden md:flex space-x-3" : "flex space-x-3"}>
              {isTrialExport == "false" || isStudent == "true" ? (
                <></>
              ) : (
                <>
                  <button>
                    <DownloadTrigger onClick={() => setShowPopup(!showPopup)} />
                  </button>
                </>
              )}
            </div>
          </div>
        </div>

        {showPopup && (
          <div>
            {isDirectoryUser ? (
              <ExportDirectoryExcel
                modules="investor"
                url={exportInvestorExcel}
                fileName={props.exportFileName}
                module_type={props.primaryTypeMasterId === Constants.primaryMasterIds.peId ? "pe" : "vc"}
                exportOptions={
                  props.menu === "investor"
                    ? investorProfileExportData
                    : props.menu === "backedipo"
                      ? investorbackedIPOExportData
                      : props.menu === "angel"
                        ? investorAngelInvestmentExportData
                        : props.menu === "incubation"
                          ? investorincubationExportData
                          : investorexitExportData
                }
                type={
                  props.menu === "investor"
                    ? "pe_vc_investment"
                    : props.menu === "backedipo"
                      ? "pe_ipo"
                      : props.menu === "angel"
                        ? "angel"
                        : props.menu === "incubation"
                          ? "incubation"
                          : props.menu === "maPeExit"
                            ? "pe_ma_exit"
                            : props.menu === "public_pevc"
                              ? "pe_pm_exit"
                              : "pe_vc_exit"
                }
                onClose={() => setShowPopup(false)}
              />
            ) : (
              <ExportPopup
                onClose={() => setShowPopup(false)}
                modules="investor"
                url={exportInvestorExcel}
                fileName={props.exportFileName}
                module_type={props.primaryTypeMasterId === Constants.primaryMasterIds.peId ? "pe" : "vc"}
                exportOptions={
                  props.menu === "investor"
                    ? investorProfileExportData
                    : props.menu === "backedipo"
                      ? investorbackedIPOExportData
                      : props.menu === "angel"
                        ? investorAngelInvestmentExportData
                        : props.menu === "incubation"
                          ? investorincubationExportData
                          : investorexitExportData
                }
                type={
                  props.menu === "investor"
                    ? "pe_vc_investment"
                    : props.menu === "backedipo"
                      ? "pe_ipo"
                      : props.menu === "angel"
                        ? "angel"
                        : props.menu === "incubation"
                          ? "incubation"
                          : props.menu === "maPeExit"
                            ? "pe_ma_exit"
                            : props.menu === "public_pevc"
                              ? "pe_pm_exit"
                              : "pe_vc_exit"
                }
              />
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default MainMenu
